import {StockSearchPillCollectionBase} from "@/classes/stock/StockSearchPillCollectionBase";
import {Booking} from "@/classes/viewmodels/Booking";
import GridColumn from "@/classes/component-classes/GridColumn";
import PickStockSearchItem from "@/classes/stock/PickStockSearchItem";
import Address from "@/classes/global/Address";
import PickStockConsignee from "@/classes/stock/PickStockConsignee";
import ContactDetail from "@/classes/bookings/ContactDetail";
import ValidatedField from "@/classes/global/ValidatedField";

export default class PickStock extends Booking {
    constructor() {

        super()

        this.warehouseJobNumber = '';
        this.searchCriteria = new PickStockSearchItem();
        this.consignee = new PickStockConsignee();
        this.newConsigneeCompany = new Address();
        this.newConsigneeContact = new ContactDetail();
        this.confirmSaveConsignee = false;
        this.confirmUpdateConsignee = false;
        this.keepExistingContacts = true;
        this.newContactSaved = false;

        this.customerRef = '';
        this.releaseDate = '';
        this.releaseTime = '';
        this.deliveryDate = '';
        this.action = '';
        this.deliveryInstructions = '';

        this.openPicksDrawer = false;
        this.openDocsDrawer = false;
        this.pickedItems = [];
        this.files = [];
        this.warehouseList = [];

        this.searchResultCurrentPage = 1;
        this.searchResultPaginationRange = 1;

        this.searchData = [];
        this.searchGroup = true;
        this.searchPills = new StockSearchPillCollectionBase();
        this.isSearchData = false;
        this.openNewConsigneeModal = false;
        this.openEditConsigneeModal = false;
        this.openAddContactModal = false;
        this.openEditContactModal = false;
        this.openCancelJobModel = false;
        this.updateSearchGrid = '';
        this.allowOverPick = false;
        this.openNoPicksModel = false;

        this.skuGroupSelected = false;

        this.metaData = {

            consignees: [],
            countries: [],
            skuGroups: [],
            validatedFields: [

            ],
            warehouses: []

        }

        this.searchGridColumns = [

            new GridColumn('1', 'SKU Group', 'skuGroup', '240', true, false, 50, '', 'isZeroQuantity'),
            new GridColumn('2', 'SKU Number', 'skuNumber', '240', true, false, 50, '', 'isZeroQuantity'),
            new GridColumn('3', 'SKU Name', 'skuName', '240', true, false, 50, '', 'isZeroQuantity'),
            new GridColumn('4', 'Warehouse', 'warehouse', '240', true, false, 50, '', 'isZeroQuantity'),
            new GridColumn('5', 'WH Location', 'location', '60', true, false, 10),
            new GridColumn('6', 'SKU Detail', 'skuProperties', '50', true, false, 50, '', 'isZeroQuantity'),
            new GridColumn('7', 'Total', 'total', '50', true, false, '', '', 'isZeroQuantity'),
            new GridColumn('8', 'Available', 'available', '60', true, false, 'zero', 'zero', 'isZeroQuantity'),
            new GridColumn('9', 'Pick Qty', 'pickQuantity', '50', true, false, 10, '','isZeroQuantity' ),
            new GridColumn('10', '', 'pick', '60', true, false, 40, ''),
            new GridColumn('11', '', 'pickAll', '60', true, false, 40, ''),
        ]

        this.pickedItemGridColumns = [

            new GridColumn('1', 'SKU Group', 'skuGroup', '150', true, false, 50 ),
            new GridColumn('2', 'SKU Number', 'skuNumber', '150', true, true, 50 ),
            new GridColumn('3', 'SKU Name', 'skuName', '180', true, true, 50 ),
            new GridColumn('4', 'SKU Composite', 'skuComposite', '200', true, false, 50 ),
            new GridColumn('5', 'Warehouse', 'warehouse', '180', true, true, 50 ),
            new GridColumn('6', 'WH Location', 'location', '100', true, false, 10),
            new GridColumn('7', 'ReOrderLevel', 'reOrderLevel', '80', true, true, 10),
            new GridColumn('8', 'Allocated', 'allocated', '60', true, true, 10),
            new GridColumn('9', 'Confirmed', 'stockSaved', '65', true, true, 10),
            new GridColumn('10', 'Comments', 'comments', '240', true, true, 10),
            new GridColumn('11', 'Un-Pick', 'unPick', '60', true, true, 10),
        ]


    }
}
